import { apiClient } from '@/api/client';
import { User } from '@/api/models';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { useEntityDrawer } from '@/hooks/useEntityDrawer';
import { queryKeys } from '@/lib/queryKeys';
import { UserFormData } from '@/pages/users/hooks/useUserMutations';
import * as React from 'react';
import { UserDrawer } from './components/UserDrawer/index';
import { UsersList } from './components/UsersList';
import { useUserMutations } from './hooks/useUserMutations';

export const UsersPage: React.FC = () => {
  const { state, actions } = useEntityDrawer<User>({
    basePath: '/users',
    queryKey: queryKeys.ADMIN_USER,
    fetchFn: async (id: number) => {
      const response = await apiClient.GET('/admin/users/{id}', {
        params: { path: { id } },
      });
      if (response.error) throw new Error('Failed to fetch user');
      return response.data as User;
    },
    supportsCreate: true,
  });

  const {
    actions: mutationActions,
    isFormLoading,
    isDeleting,
  } = useUserMutations();

  const handleFormSubmit = async (formData: UserFormData) => {
    await mutationActions.handleFormSubmit(formData, state.mode, state.entity);
  };

  return (
    <DashboardLayout>
      <ProtectedRoute action='read' subject='User'>
        <UsersList
          onRowClick={user => actions.open(user.id!)}
          onEditUser={user => actions.edit(user.id!)}
          onDeleteUser={mutationActions.handleDeleteUser}
          onCreateUser={actions.create}
          isDeleting={isDeleting}
        />

        <UserDrawer
          onFormSubmit={handleFormSubmit}
          onDeleteUser={mutationActions.handleDeleteUser}
          isFormLoading={isFormLoading}
        />
      </ProtectedRoute>
    </DashboardLayout>
  );
};
